export const Texts = {
  CUSTOMER_SCHEDULED_PURCHASE: "Cliente Compra Programada",
  ADD_TO_CART: "Adicionar à cesta de doação",
  PRODUCT_UNAVAILABLE: "Que pena, produto sem estoque no momento"
};
